import type { TelemetryBatchQueryItemDto } from "@/lib/api/types";

import type { HmiCanvasDocument } from "../schema/hmi-canvas.schema";
import { sourceFingerprint, sourceQueryId } from "./sourceFingerprint";

export function buildTelemetryQueries(document: HmiCanvasDocument): TelemetryBatchQueryItemDto[] {
  const queries = new Map<string, TelemetryBatchQueryItemDto>();

  for (const binding of document.bindings) {
    if (binding.source.kind !== "telemetry") {
      continue;
    }
    const deviceId = binding.source.deviceId?.trim();
    const hasChannel = Boolean(binding.source.channel?.trim());
    const hasFormula = Boolean(binding.source.formula?.trim());
    const hasMetric = Boolean(binding.source.metricId?.trim());
    if (!deviceId || [hasChannel, hasFormula, hasMetric].filter(Boolean).length !== 1) {
      continue;
    }
    if ((binding.source.readMode ?? "live") === "live" && hasChannel) {
      continue;
    }
    const fingerprint = sourceFingerprint(binding.source);
    if (queries.has(fingerprint)) {
      continue;
    }
    queries.set(fingerprint, {
      widget_id: sourceQueryId(binding.source),
      device_id: deviceId,
      channel: binding.source.channel?.trim() || null,
      formula: binding.source.formula?.trim() || null,
      metric_id: binding.source.metricId?.trim() || null,
      time_range: binding.source.timeRange,
      aggregation: binding.source.aggregation,
    });
  }

  return [...queries.values()];
}
